/**
 * Endpoints de series.
 */

import { GetSeriesResponse, type Serie } from '@/api/contracts/series';
import { getDb } from '@/api/mock/db';

const MOCK_LATENCY_MS = 150;
function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** GET /api/series — sin filtros por ahora (cliente filtra in memory). */
export async function getSeries(): Promise<Serie[]> {
  await delay(MOCK_LATENCY_MS);
  return GetSeriesResponse.parse(getDb().series);
}
